export const CREATE_REPORT = "CREATE_REPORT";
export const LOAD_AILMENTS = "LOAD_AILMENTS";
export const LOAD_CHOOSER = "LOAD_CHOOSER";
export const LOAD_FOOD_CHOOSER = "LOAD_FOOD_CHOOSER";
export const LOAD_FOODS_BY_GROUP = "LOAD_FOODS_BY_GROUP";
export const LOAD_FOODS = "LOAD_FOODS";
export const LOAD_INGREDIENTS = "LOAD_INGREDIENTS";
export const LOAD_NUTRIENTS_CHOOSER = "LOAD_NUTRIENTS_CHOOSER";
export const LOAD_NUTRIENTS = "LOAD_NUTRIENTS";
export const LOAD_REPORT = "LOAD_REPORT";
export const LOAD_USER = "LOAD_USER";